import { SettingsModal, SETTINGS_TABS } from "./index";
import { GeneralPanel } from "./GeneralPanel";

// Route element for /settings/general.
export const GeneralSettings = () => (
  <SettingsModal active={SETTINGS_TABS.GENERAL}>
    <GeneralPanel />
  </SettingsModal>
);
